document.addEventListener("DOMContentLoaded", function() {
document.querySelectorAll("#hat-style .style-item").forEach(item => {
  item.addEventListener("click", function(){
console.log(this.dataset.product)
    const product = JSON.parse(this.dataset.product);
    document.querySelector('[onclick="toggleDropdown(\'style\')"]').textContent = product.title;
    document.getElementById("style").classList.remove("show");

    // Reset dependent dropdown labels
    document.querySelector('[onclick="toggleDropdown(\'color\')"]').innerHTML = '<span>selet color</span>';
    document.querySelector('[onclick="toggleDropdown(\'leather\')"]').innerHTML = '<span>selet Leather</span>';
    document.querySelector('[onclick="toggleDropdown(\'shape\')"]').innerHTML = '<span>selet Patch </span>';

    // Reset hidden inputs so the user is forced to select them again
    document.getElementById('quick-order__product-id').value = '';
    document.getElementById('quick-order__leather-color').value = '';
    document.getElementById('quick-order__patch-shape').value = '';

    // Hide bulk pricing box since the variant is reset
    document.getElementById('pricing-box').style.display = 'none';

    const colorContainer = document.getElementById("hat-color");
    const leatherContainer = document.getElementById("hat-leather");
    const shapeContainer = document.getElementById("hat-shape");

    colorContainer.innerHTML = "";
    leatherContainer.innerHTML = "";
    shapeContainer.innerHTML = "";

    /* ------------------------
       HAT COLOR (Variants)
    -------------------------*/

    product.variants.forEach(variant => {

      const li = document.createElement("li");
    li.setAttribute("data-variant-id", variant.id);
    li.setAttribute("data-price", variant.price);
      li.innerHTML = `
        <div class="prdct_style">
          <div class="left_p_img">
            <img src="${variant.image}">
          </div>
          <div class="right_desc">
            <h4>${variant.title}</h4>
            <span>$${variant.price}</span>
          </div>
        </div>
      `;
    
      colorContainer.appendChild(li);

    });

    /* ------------------------
       LEATHER (Metaobjects)
    -------------------------*/

    product.leathers.forEach(leather => {

      const li = document.createElement("li");

      li.innerHTML = `
        <div class="prdct_style">
          <div class="left_p_img">
            <img src="${leather.image}">
          </div>
          <div class="right_desc">
            <h4>${leather.title}</h4>
          </div>
        </div>
      `;

      leatherContainer.appendChild(li);

    });

    /* ------------------------
       PATCH SHAPE (Metaobjects)
    -------------------------*/

    product.shapes.forEach(shape => {

      const li = document.createElement("li");

      li.innerHTML = `
        <div class="prdct_style">
          <div class="left_p_img">
            <img src="${shape.image}">
          </div>
          <div class="right_desc">
            <h4>${shape.title}</h4>
          </div>
        </div>
      `;

      shapeContainer.appendChild(li);

    });

  });

});
function updateBulkPricing(price){

  const isWholesale = window.theme && window.theme.isWholesale;

  const retailDiscounts = {
    6: 0.9,
    12: 0.8,
    24: 0.7,
    48: 0.6,
    72: 0.55,
    150: 0.5,
    250: 0.47
  };

  const wholesaleDiscounts = {
    6: 0.8,
    12: 0.7,
    24: 0.6,
    48: 0.55,
    100: 0.5,
    250: 0.47
  };

  const discounts = isWholesale ? wholesaleDiscounts : retailDiscounts;

  Object.keys(discounts).forEach(qty => {

    const discounted = price * discounts[qty];
    const el = document.getElementById(`price-${qty}`);
    if (el) {
      el.textContent = "$" + discounted.toFixed(2);
    }

  });

}
document.getElementById("hat-color").addEventListener("click", function(e){

  const li = e.target.closest("li");
  if(!li) return;
    const title = li.querySelector("h4").innerText;

  document.querySelector('[onclick="toggleDropdown(\'color\')"]').textContent = title;
  const variantId = li.dataset.variantId;
  document.getElementById('quick-order__product-id').value = variantId;
  document.getElementById("color").classList.remove("show");
  const price = parseFloat(li.dataset.price);

  updateBulkPricing(price);
  document.getElementById('pricing-box').style.display='block';
  

});
document.getElementById("hat-leather").addEventListener("click", function(e){

  const li = e.target.closest("li");
  if(!li) return;
    const title = li.querySelector("h4").innerText;

  document.querySelector('[onclick="toggleDropdown(\'leather\')"]').textContent = title;
   document.getElementById('quick-order__leather-color').value = title;
  document.getElementById("leather").classList.remove("show");

});
document.getElementById("hat-shape").addEventListener("click", function(e){

  const li = e.target.closest("li");
  if(!li) return;
const title = li.querySelector("h4").innerText;

  document.querySelector('[onclick="toggleDropdown(\'shape\')"]').textContent = title;
  document.getElementById('quick-order__patch-shape').value = title;
  document.getElementById("shape").classList.remove("show");

});
document.getElementById("imageUpload").addEventListener("change", function() {

  const file = this.files[0];
  if (!file) return;

  /* show file name */
  document.querySelector(".upload-text").textContent = file.name;

  /* show image preview */
  const reader = new FileReader();
  reader.onload = function(e) {
    const preview = document.getElementById("logoPreview");
    preview.src = e.target.result;
    preview.style.display = "block";
  };

  reader.readAsDataURL(file);

});

document.querySelector('.quick-order__form').addEventListener('submit', async function(e){
  e.preventDefault();

  const productId = document.getElementById('quick-order__product-id').value;
  const leather = document.getElementById('quick-order__leather-color').value;
  const shape = document.getElementById('quick-order__patch-shape').value;
  const quantity = document.querySelector('[name="quantity"]')?.value || 1;
  const fileInput = document.getElementById("imageUpload");
  const orderNotes = this.querySelector('[name="properties[Order Notes]"]')?.value.trim() || '';
const cartStore = window.theme.cart.store.getState();
const errorBox = document.querySelector('.form-error');

  if(!productId){
    errorBox.textContent = "Please select hat style and color";
  return;
  }

  if(!leather){
    errorBox.textContent = "Please select a Leather";
    return;
  }

  if(!shape){
    errorBox.textContent = "Please select a Patch Shape";
    return;
  }

   const logoFile = document.getElementById('imageUpload');
  if(!logoFile.files || !logoFile.files.length){
    errorBox.textContent = "Please upload a logo image";
    e.preventDefault();
    return;
  }

  const formData = new FormData();

  formData.append('id', productId);
  formData.append('quantity', quantity);

  formData.append('properties[Leather]', leather);
  formData.append('properties[Shape]', shape);

  // ✅ FILE UPLOAD WORKS HERE
  if (fileInput.files[0]) {
    formData.append('properties[Logo]', fileInput.files[0]);
  }

  if (orderNotes) {
    formData.append('properties[Order Notes]', orderNotes);
  }

  try {
    /* ------------------------
       ADD TO CART (REAL FILE)
    -------------------------*/
    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (orderNotes) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: orderNotes })
      });
    }

    /* ------------------------
       🔥 CRITICAL: SYNC THEME STORE
    -------------------------*/
    const cart = await fetch('/cart.js').then(res => res.json());

    window.theme.cart.store.setState((state) => ({
      ...state,
      products: cart
    }));

    /* ------------------------
       OPEN DRAWER
    -------------------------*/
    if (window.theme?.cart?.openCart) {
      window.theme.cart.openCart();
    } else {
       document.querySelector('[href="/cart"]')?.click();
    }

  } catch (err) {
    console.error(err);
  }
});
 /* ------------------------
       Close Dropdown Clicking outside
    -------------------------*/
document.addEventListener('click', function(e) {
  if (!e.target.closest('.dropdown')) {
    document.querySelectorAll('.dropdown-content').forEach(function(dd) {
      dd.classList.remove('show');
    });
  }
});
});